import { create } from 'zustand';

export type ToastKind = 'info' | 'success' | 'warn' | 'error';

export interface ToastItem {
  id: number;
  kind: ToastKind;
  text: string;
  ttl: number;
}

interface ToastState {
  items: ToastItem[];
  push: (kind: ToastKind, text: string, ttl?: number) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToast = create<ToastState>((set, get) => ({
  items: [],
  push: (kind, text, ttl = 3500) => {
    const id = nextId++;
    set((s) => ({ items: [...s.items, { id, kind, text, ttl }] }));
    if (typeof window !== 'undefined') {
      window.setTimeout(() => get().dismiss(id), ttl);
    }
  },
  dismiss: (id) => set((s) => ({ items: s.items.filter((it) => it.id !== id) })),
}));
